import { render, staticRenderFns } from "./query2.vue?vue&type=template&id=a02143b0&scoped=true"
import script from "./query2.vue?vue&type=script&lang=js"
export * from "./query2.vue?vue&type=script&lang=js"
import style0 from "./query2.vue?vue&type=style&index=0&id=a02143b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02143b0",
  null
  
)

export default component.exports